import React, { useState, useEffect, useRef } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Editor } from 'primereact/editor';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import PrintTemplateService from '../../services/PrintTemplateService';


const placeholders = [
    { label: 'Firma Adı', value: '{{FirmaAdi}}' },
    { label: 'Firma Adresi', value: '{{FirmaAdresi}}' },
    { label: 'Firma Telefon', value: '{{FirmaTelefon}}' },
    { label: 'Satış Tarihi', value: '{{SatisTarihi}}' },
    { label: 'Fiş No', value: '{{FisNo}}' },
    { label: 'Müşteri No', value: '{{MusteriNo}}' },
    { label: 'Müşteri Adı', value: '{{MusteriAdi}}' },
    { label: 'Müşteri Adresi', value: '{{MusteriAdresi}}' },
    { label: 'Müşteri Telefon', value: '{{MusteriTelefon}}' },
    { label: 'Müşteri Bakiyesi', value: '{{MusteriBakiyesi}}' },
    { label: 'Ödeme Yöntemi', value: '{{OdemeYontemi}}' },
    { label: 'Odenen Tutar', value: '{{OdenenTutar}}' },
    { label: 'Genel Toplam', value: '{{GenelToplam}}' },
    { label: 'Satış Notu (İşlem)', value: '{{SatisNotu}}' },
    { label: 'Şirket Fiş Alt Notu', value: '{{FirmaFisNotu}}' },
    { label: 'Teslim Alan Kutusu', value: '{{TeslimAlan}}' },
    { label: 'Ürün Tablosu / Listesi', value: '{{UrunTablosu}}' }
];
const designElements = [
    {
        label: 'Düz Çizgi',
        value: '{{DuzCizgi}}',
        type: 'text',
        icon: 'pi pi-minus'
    },
    {
        label: 'Kesik Çizgi',
        value: '{{KesikCizgi}}',
        type: 'text',
        icon: 'pi pi-minus'
    },
    {
        label: 'Noktalı Çizgi',
        value: '{{NoktaliCizgi}}',
        type: 'text',
        icon: 'pi pi-minus'
    },
    {
        label: 'Boşluk',
        value: '{{Bosluk}}',
        type: 'text',
        icon: 'pi pi-arrows-v'
    },
    {
        label: 'İmza Alanı',
        value: '{{ImzaAlani}}',
        type: 'text',
        icon: 'pi pi-pencil'
    },
     {
        label: 'Kaşe Alanı',
        value: '{{KaseAlani}}',
        type: 'text',
        icon: 'pi pi-verified'
    }
];


const defaultTemplates = {
    info: `<div style="text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 10px;">
    <div style="font-size: 14pt; font-weight: bold; text-transform: uppercase;">{{FirmaAdi}}</div>
    <div style="font-size: 10pt;">{{FirmaAdresi}}</div>
    <div style="font-size: 10pt;">{{FirmaTelefon}}</div>
    <div style="font-size: 12pt; margin-top: 5px; font-weight: bold; text-decoration: underline;">BİLGİ FİŞİ</div>
</div>
<div style="font-size: 10pt; line-height: 1.2; margin-bottom: 10px;">
    <div><strong>Satış Tarihi:</strong> {{SatisTarihi}}</div>
    <div><strong>Fiş No:</strong> {{FisNo}}</div>
    <div><strong>Müşteri:</strong> {{MusteriAdi}}</div>
    <div><strong>Telefon:</strong> {{MusteriTelefon}}</div>
</div>
{{UrunTablosu}}`,

    detailed: `<div style="text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 10px;">
    <div style="font-size: 14pt; font-weight: bold; text-transform: uppercase;">{{FirmaAdi}}</div>
    <div style="font-size: 10pt;">{{FirmaAdresi}}</div>
    <div style="font-size: 10pt;">{{FirmaTelefon}}</div>
    <div style="font-size: 12pt; margin-top: 5px; font-weight: bold; text-decoration: underline;">DETAYLI BİLGİ FİŞİ</div>
</div>
<div style="font-size: 10pt; line-height: 1.2; margin-bottom: 10px;">
    <div><strong>Satış Tarihi:</strong> {{SatisTarihi}}</div>
    <div><strong>Fiş No:</strong> {{FisNo}}</div>
    <div><strong>Müşteri:</strong> {{MusteriAdi}}</div>
    <div><strong>Adres:</strong> {{MusteriAdresi}}</div>
    <div><strong>Telefon:</strong> {{MusteriTelefon}}</div>
</div>
{{UrunTablosu}}
<div style="border-top: 2px solid #000; margin-top: 10px; padding-top: 5px; font-weight: bold;">
    <div style="display: flex; justify-content: space-between;">
        <span>GENEL TOPLAM:</span>
        <span>{{GenelToplam}}</span>
    </div>
    <div style="display: flex; justify-content: space-between;">
        <span>MÜŞTERİ BAKİYESİ:</span>
        <span>{{MusteriBakiyesi}}</span>
    </div>
</div>
<div style="margin-top: 10px; text-align: center; border: 1px dotted #000; padding: 5px;">
    {{SatisNotu}}
</div>
{{TeslimAlan}}`,

    collection: `<div style="text-align: center; border-bottom: 1px dashed #000; padding-bottom: 5px; margin-bottom: 10px;">
    <div style="font-size: 14pt; font-weight: bold; text-transform: uppercase;">{{FirmaAdi}}</div>
    <div style="font-size: 10pt;">{{FirmaAdresi}}</div>
    <div style="font-size: 10pt;">{{FirmaTelefon}}</div>
    <div style="font-size: 12pt; margin-top: 5px; font-weight: bold; text-decoration: underline;">TAHSİLAT MAKBUZU</div>
</div>
<div style="font-size: 10pt; line-height: 1.5;">
    <div><strong>Müşteri Adı:</strong> {{MusteriAdi}}</div>
    <div><strong>Telefon:</strong> {{MusteriTelefon}}</div>
    <div><strong>Tarih:</strong> {{SatisTarihi}}</div>
    <div><strong>Ödeme Yöntemi:</strong> {{OdemeYontemi}}</div>
    <div style="font-size: 12pt; font-weight: bold; border-top: 1px solid #000; margin-top: 5px; padding-top: 5px;">
        <strong>Ödenen Tutar:</strong> {{OdenenTutar}}
    </div>
    <div style="margin-top: 10px; font-style: italic;">
        <strong>Açıklama:</strong> {{SatisNotu}}
    </div>
</div>`
};

export default function PrintSettingsPage() {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
    
    const [editorVersion, setEditorVersion] = useState(0);
    const [quillInstance, setQuillInstance] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [templates, setTemplates] = useState({ info: '', detailed: '', collection: '' });
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);

    const types = React.useMemo(() => ['info', 'detailed', 'collection'], []);

    const loadTemplates = React.useCallback(async () => {
        setLoading(true);
        try {
            const results = await Promise.all(types.map(type => PrintTemplateService.getTemplate(type)));
            const newTemplates = { ...templates };
            results.forEach((res, index) => {
                if (res.success && res.data) {
                    newTemplates[types[index]] = res.data.content;
                } else {
                    newTemplates[types[index]] = defaultTemplates[types[index]];
                }
            });
            setTemplates(newTemplates);
        } catch (error) {
            console.error('Tasarımlar yüklenirken hata oluştu:', error);
            // Hata olsa bile varsayılanları set et
            setTemplates({
                info: defaultTemplates.info,
                detailed: defaultTemplates.detailed,
                collection: defaultTemplates.collection
            });
        } finally {
            setLoading(false);
        }
    }, [types]);

    useEffect(() => {
        loadTemplates();
    }, [loadTemplates]);

    const handleSave = async () => {
        const type = types[activeIndex];
        const content = templates[type];

        try {
            setLoading(true);
            const res = await PrintTemplateService.saveTemplate({
                templateType: type,
                content: content
            });
            if (res.success) {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Tasarım kaydedildi.' });
            } else {
                toast.current.show({ severity: 'error', summary: 'Hata', detail: res.message || 'Kayıt başarısız.' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Bir hata oluştu.' });
        } finally {
            setLoading(false);
        }
    };

    const updateTemplate = React.useCallback((content) => {
        const type = types[activeIndex];
        setTemplates(prev => {
            if (prev[type] === content) return prev;
            return { ...prev, [type]: content };
        });
    }, [activeIndex, types]);

   const insertEditorContent = React.useCallback((item) => {
    if (!quillInstance) {
        navigator.clipboard.writeText(item.value);

        toast.current.show({
            severity: 'info',
            summary: 'Kopyalandı',
            detail: `${item.label} kopyalandı. Editöre yapıştırabilirsiniz.`,
            life: 2000
        });

        return;
    }

    quillInstance.focus();

    const range = quillInstance.getSelection(true);
    const index = range ? range.index : quillInstance.getLength();

    if (item.type === 'html') {
        quillInstance.clipboard.dangerouslyPasteHTML(index, item.value, 'user');
    } else {
        quillInstance.insertText(index, item.value, 'user');
        quillInstance.setSelection(index + item.value.length);
    }

    setTimeout(() => {
        const type = types[activeIndex];
        const html = quillInstance.root.innerHTML;

        setTemplates(prev => ({
            ...prev,
            [type]: html
        }));

        toast.current.show({
            severity: 'info',
            summary: 'Eklendi',
            detail: `${item.label} tasarıma eklendi.`,
            life: 1500
        });
    }, 0);
}, [quillInstance, activeIndex, types]);

   useEffect(() => {
    if (!quillInstance || !quillInstance.root) return;

    const root = quillInstance.root;

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();

        event.dataTransfer.dropEffect = 'copy';
        root.style.border = '2px dashed #10b981';
        root.style.backgroundColor = '#f0fdf4';
    };

    const handleDragLeave = () => {
        root.style.border = 'none';
        root.style.backgroundColor = '';
    };

    const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    root.style.border = 'none';
    root.style.backgroundColor = '';

    let item = null;

    const jsonData = event.dataTransfer.getData('application/json');

    if (jsonData) {
        try {
            item = JSON.parse(jsonData);
        } catch {
            item = null;
        }
    }

    if (!item) {
        const textData =
            event.dataTransfer.getData('text/plain') ||
            event.dataTransfer.getData('Text');

        if (!textData) return;

        item = {
            label: textData,
            value: textData,
            type: textData.includes('<') ? 'html' : 'text'
        };
    }

    quillInstance.focus();

    setTimeout(() => {
        const range = quillInstance.getSelection(true);
        const index = range ? range.index : quillInstance.getLength();

        if (item.type === 'html') {
            quillInstance.clipboard.dangerouslyPasteHTML(index, item.value, 'user');
        } else {
            quillInstance.insertText(index, item.value, 'user');
            quillInstance.setSelection(index + item.value.length);
        }

        const html = quillInstance.root.innerHTML;
        const type = types[activeIndex];

        setTemplates(prev => ({
            ...prev,
            [type]: html
        }));

        toast.current.show({
            severity: 'info',
            summary: 'Eklendi',
            detail: `${item.label} eklendi.`,
            life: 1500
        });
    }, 0);
};

    root.addEventListener('dragover', handleDragOver);
    root.addEventListener('dragleave', handleDragLeave);
    root.addEventListener('drop', handleDrop);

    return () => {
        root.removeEventListener('dragover', handleDragOver);
        root.removeEventListener('dragleave', handleDragLeave);
        root.removeEventListener('drop', handleDrop);
    };
}, [quillInstance, activeIndex, types]);
   const onDragStart = (event, item) => {
    event.dataTransfer.setData("application/json", JSON.stringify(item));
    event.dataTransfer.setData("text/plain", item.value);
    event.dataTransfer.setData("Text", item.value);
    event.dataTransfer.effectAllowed = "copy";
};

    const renderToolItem = (item, groupType = 'placeholder') => {
    const isPlaceholder = groupType === 'placeholder';
    const isUsed = isPlaceholder && currentTemplate?.includes(item.value);

    return (
        <div
            key={item.value}
            draggable
            onDragStart={(e) => onDragStart(e, {
                ...item,
                type: item.type || 'text'
            })}
            className={`flex align-items-center justify-content-between p-2 mb-2 border-round border-1 cursor-grab active:cursor-grabbing transition-colors ${
                isUsed
                    ? 'bg-emerald-50 border-emerald-200 hover:bg-emerald-100'
                    : 'bg-slate-50 border-slate-200 hover:bg-slate-100'
            }`}
            onClick={() => insertEditorContent({
                ...item,
                type: item.type || 'text'
            })}
            title="Tıklayarak ekleyin veya sürükleyip bırakın"
        >
            <div className="flex align-items-center gap-2">
                {item.icon && (
                    <i className={`${item.icon} text-slate-500 text-sm`}></i>
                )}

                <span className={`text-sm font-medium ${
                    isUsed ? 'text-emerald-700' : 'text-slate-700'
                }`}>
                    {item.label}
                </span>
            </div>

            {isPlaceholder ? (
                <code className={`text-xs px-2 py-1 border-round font-bold ${
                    isUsed
                        ? 'bg-emerald-200 text-emerald-800'
                        : 'bg-blue-100 text-blue-700'
                }`}>
                    {item.value}
                </code>
            ) : (
                <span className="text-xs px-2 py-1 border-round font-bold bg-purple-100 text-purple-700">
                    Ekle
                </span>
            )}
        </div>
    );
};

const loadDefaultTemplateToEditor = () => {
    const type = types[activeIndex];
    const defaultContent = defaultTemplates[type] || '';

    setTemplates(prev => ({
        ...prev,
        [type]: defaultContent
    }));

    toast.current.show({
        severity: 'info',
        summary: 'Varsayılan Tasarım Yüklendi',
        detail: 'Sistem varsayılan tasarımı editöre yüklendi. Kalıcı olması için kaydetmelisiniz.',
        life: 2500
    });
};

    const currentTemplate = templates[types[activeIndex]];

    // Mock item table for preview
    const mockItemTable = `
        <table style="width: 100%; border-collapse: collapse; font-size: 9pt; margin-top: 5px;">
            <thead>
                <tr style="border-bottom: 1px solid #000;">
                    <th style="text-align: left;">Ürün</th>
                    <th style="text-align: center;">Adet</th>
                    <th style="text-align: right;">Fiyat</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Örnek Ürün 1</td>
                    <td style="text-align: center;">2</td>
                    <td style="text-align: right;">50,00 ₺</td>
                </tr>
                <tr>
                    <td>Örnek Ürün 2</td>
                    <td style="text-align: center;">1</td>
                    <td style="text-align: right;">120,00 ₺</td>
                </tr>
            </tbody>
        </table>
    `;
const escapeRegExp = (value) => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

const replaceDesignToken = (html, token, replacement) => {
    const escapedToken = escapeRegExp(token);

    // Quill genelde token'ı <p>{{DuzCizgi}}</p> şeklinde tutar.
    // Önce komple p bloğunu değiştiriyoruz.
    html = html.replace(
        new RegExp(`<p>\\s*${escapedToken}\\s*</p>`, 'g'),
        replacement
    );

    // Eğer token başka bir div/span içinde kalmışsa onu da yakala.
    html = html.replace(
        new RegExp(escapedToken, 'g'),
        replacement
    );

    return html;
};
    const getPreviewHtml = () => {
        let html = currentTemplate ;
        const designElementHtml = {
    '{{DuzCizgi}}': `
        <div style="border-top: 1px solid #000; "></div>
    `,
    '{{KesikCizgi}}': `
        <div style="border-top: 1px dashed #000;"></div>
    `,
    '{{NoktaliCizgi}}': `
        <div style="border-top: 1px dotted #000;"></div>
    `,
    '{{Bosluk}}': ` 
        <div style="height: 12px;"></div>
    `,
    '{{ImzaAlani}}': `
        <div style="text-align: center;">
            <div style="border-top: 1px solid #000; width: 70%; margin: 10px auto 0 auto;"></div>
            <div style="font-size: 9pt; margin-top: 4px;">İmza</div>
        </div>
    `,
     '{{KaseAlani}}':
    `
    <div class="receipt-stamp-sign-area">
        <div class="receipt-stamp-box">Kaşe / İmza</div>
    </div>
    `
};
Object.keys(designElementHtml).forEach(key => {
    html = html.replace(new RegExp(key, 'g'), designElementHtml[key]);
});
   html = replaceDesignToken(
        html,
        '{{DuzCizgi}}',
        '<div class="receipt-line receipt-line-solid"></div>'
    );

    html = replaceDesignToken(
        html,
        '{{KesikCizgi}}',
        '<div class="receipt-line receipt-line-dashed"></div>'
    );

    html = replaceDesignToken(
        html,
        '{{NoktaliCizgi}}',
        '<div class="receipt-line receipt-line-dotted"></div>'
    );

    html = replaceDesignToken(
        html,
        '{{Bosluk}}',
        '<div class="receipt-space"></div>'
    );

    html = replaceDesignToken(
        html,
        '{{ImzaAlani}}',
        `
        <div class="receipt-sign-area">
            <div class="receipt-sign-line"></div>
            <div class="receipt-sign-text">İmza</div>
        </div>
        `
    );
    html = replaceDesignToken(
    html,
    '{{KaseAlani}}',
    `
    <div class="receipt-stamp-sign-area">
        <div class="receipt-stamp-box">Kaşe</div>
    </div>
    `
);
        // Replace complex placeholders first
        const teslimAlanHtml = `
            <div style=" text-align: center; border: 2px dashed #000;">
                <div style="font-weight: bold; text-transform: uppercase;">Teslim Alan</div>
                <div style="margin-top: 5px;">Ahmet Yılmaz</div>
                <div style=" border-top: 1px solid #000; width: 80%; margin-left: 10%;"></div>
            </div>
        `;
        html = html.replace(/{{TeslimAlan}}/g, teslimAlanHtml);

        const mockData = {
            '{{FirmaAdi}}': 'KASAM BENİM A.Ş.',
            '{{FirmaAdresi}}': 'Merkez Mah. Teknoloji Cad. No:1 İstanbul',
            '{{FirmaTelefon}}': '0212 000 00 00',
            '{{SatisTarihi}}': new Date().toLocaleString('tr-TR'),
            '{{FisNo}}': 'SAT-2023-0001',
            '{{MusteriNo}}': '105',
            '{{MusteriAdi}}': 'Ahmet Yılmaz',
            '{{MusteriAdresi}}': 'Örnek Mah. Gül Sok. No:5 Daire:2',
            '{{MusteriTelefon}}': '0555 111 22 33',
            '{{MusteriBakiyesi}}': '450,00 ₺',
            '{{OdemeYontemi}}': 'Nakit',
            '{{OdenenTutar}}': '220,00 ₺',
            '{{GenelToplam}}': '220,00 ₺',
            '{{SatisNotu}}': 'Bu satışa özel bir nottur.',
            '{{FirmaFisNotu}}': 'Bizi tercih ettiğiniz için teşekkür ederiz. (Şirket Ayarlarından Değişir)',
            '{{UrunTablosu}}': mockItemTable
        };

        Object.keys(mockData).forEach(key => {
            html = html.replace(new RegExp(key, 'g'), mockData[key]);
        });

        return html;
    };
const editorHeader = (
    <div className="ql-toolbar-custom">
         <span className="ql-formats">
            <select className="ql-font" defaultValue="">
                <option value="">Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option> 
            </select>

            <select className="ql-size" defaultValue="">
                <option value="">Normal</option>
                <option value="small">Küçük</option>
                <option value="large">Büyük</option>
                <option value="huge">Çok Büyük</option>
            </select>
        </span> 

        <span className="ql-formats">
            <button className="ql-bold" aria-label="Kalın"></button>
            <button className="ql-italic" aria-label="İtalik"></button>
            <button className="ql-underline" aria-label="Altı çizili"></button>
            <button className="ql-strike" aria-label="Üstü çizili"></button>
        </span>

        <span className="ql-formats">
            <select className="ql-color"></select>
            <select className="ql-background"></select>
        </span>

        <span className="ql-formats">
            <button className="ql-list" value="ordered" aria-label="Numaralı liste"></button>
            <button className="ql-list" value="bullet" aria-label="Madde listesi"></button>
        </span>

        <span className="ql-formats">
            <select className="ql-align"></select>
        </span>

        <span className="ql-formats">
            <button className="ql-clean" aria-label="Biçimi temizle"></button>
        </span>
    </div>
);
const editorFormats = [
    'font',
    'size',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'list',
    'align'
];
    return (
        <div className="p-2 space-y-4 animate-fade-in bg-[#f8fafc] min-h-screen">
            <Toast ref={toast} appendTo={mounted ? document.body : "self"} />

            <div className="flex justify-between items-center mb-4">
                <div className="flex items-center gap-3">
                    <div className="!bg-blue-600 p-4 rounded-xl shadow-lg shadow-blue-500/20">
                        <i className="pi pi-print text-white text-xl"></i>
                    </div>
                    <div>
                        <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Yazdırma Tasarımları</h1>
                        <p className="text-slate-500 text-sm font-medium">80mm Termal fiş yazıcısı için çıktı tasarımlarını buradan düzenleyebilirsiniz.</p>
                    </div>
                </div>
                    <div className="flex gap-2">
                        <Button
                            label="VARSAYILANI YÜKLE"
                            icon="pi pi-refresh"
                            className="p-button-secondary rounded-xl font-black px-5 py-3"
                            onClick={loadDefaultTemplateToEditor}
                            type="button"
                        />

                        <Button
                            label="TASARIMI KAYDET"
                            icon="pi pi-save"
                            className="p-button-success rounded-xl font-black px-6 py-3 shadow-lg"
                            onClick={handleSave}
                            loading={loading}
                        />
                    </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
                {/* Sol Taraf: Placeholders */}
                <div className="col-span-12 lg:col-span-3">
                       <Card title="Tasarım Araçları" className="h-full border-round-xl shadow-1">
        <p className="text-xs text-slate-500 mb-3 font-medium">
            Dinamik verileri ve tasarım elemanlarını tıklayarak veya sürükleyip bırakarak fiş tasarımına ekleyebilirsiniz.
        </p>

        <div className="mb-4">
            <div className="flex align-items-center gap-2 mb-2">
                <i className="pi pi-database text-blue-600"></i>
                <h3 className="text-sm font-black text-slate-700 uppercase m-0">
                    Dinamik Veriler
                </h3>
            </div>

            <div className="overflow-y-auto pr-1" style={{ maxHeight: '260px' }}>
                {placeholders.map(item => renderToolItem({
                    ...item,
                    type: 'text'
                }, 'placeholder'))}
            </div>
        </div>

        <div>
            <div className="flex align-items-center gap-2 mb-2 pt-3 border-top-1 border-slate-200">
                <i className="pi pi-palette text-purple-600"></i>
                <h3 className="text-sm font-black text-slate-700 uppercase m-0">
                    Tasarım Elemanları
                </h3>
            </div>

            <div className="overflow-y-auto pr-1" style={{ maxHeight: '260px' }}>
                {designElements.map(item => renderToolItem(item, 'design'))}
            </div>
        </div>
    </Card>
                </div>

                {/* Orta: Editör */}
                <div className="col-span-12 lg:col-span-6">
                    <Card className="border-round-xl shadow-1 p-0 overflow-hidden">
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                            <TabPanel header="Bilgi Fişi" leftIcon="pi pi-file mr-2" />
                            <TabPanel header="Detaylı Bilgi Fişi" leftIcon="pi pi-list mr-2" />
                            <TabPanel header="Tahsilat" leftIcon="pi pi-money-bill mr-2" />
                        </TabView>

                        <div className="p-3">
                            <Editor
                             key={`${types[activeIndex]}-${editorVersion}`}
                             value={currentTemplate}
                             onTextChange={(e) => updateTemplate(e.htmlValue)}
                             onLoad={(quill) => setQuillInstance(quill)}
                             style={{ height: '500px' }}
                             placeholder="Tasarımınızı buraya yapın..."
                             headerTemplate={editorHeader}
                             formats={editorFormats}
                        />
                        </div>
                    </Card>
                </div>

                {/* Sağ: Önizleme */}
                <div className="col-span-12 lg:col-span-3">
                        <Card title="Önizleme (80mm)" className="h-full border-round-xl shadow-1">
                            <div className="bg-white border-1 border-slate-200 p-3 mx-auto shadow-4 overflow-y-auto custom-scrollbar"
                                 style={{
                                    width: '80mm',
                                    minHeight: '120mm',
                                    maxHeight: 'calc(100vh - 250px)',
                                    fontFamily: 'Arial, sans-serif',
                                    color: '#000',
                                    backgroundColor: '#fff'
                                 }}>
                                <style>
        {`
            .preview-content .ql-align-center { text-align: center; }
            .preview-content .ql-align-right { text-align: right; }
            .preview-content .ql-align-justify { text-align: justify; }

            .preview-content p {
                margin: 0;
                padding: 0;
                min-height: 0;
                line-height: 1.15;
            }

            .preview-content p:empty {
                display: none;
            }

            .preview-content .receipt-line {
                width: 100%;
                height: 0;
                line-height: 0;
                font-size: 0;
                padding: 0;
                margin: 2px 0;
            }

            .preview-content .receipt-line-solid {
                border-top: 1px solid #000;
            }

            .preview-content .receipt-line-dashed {
                border-top: 1px dashed #000;
            }

            .preview-content .receipt-line-dotted {
                border-top: 1px dotted #000;
            }

            .preview-content .receipt-space {
                height: 6px;
                line-height: 0;
                font-size: 0;
            }

            .preview-content .receipt-sign-area {
                margin-top: 12px;
                text-align: center;
                line-height: 1.1;
            }

            .preview-content .receipt-sign-line {
                border-top: 1px solid #000;
                width: 70%;
                margin: 20px auto 0 auto;
                height: 0;
                line-height: 0;
                font-size: 0;
            }

            .preview-content .receipt-sign-text {
                font-size: 9pt;
                margin-top: 3px;
            }

            .preview-content ul,
            .preview-content ol {
                padding-left: 1.5em;
                margin: 0.5em 0;
            }
                .receipt-stamp-area {
        margin-top: 14px;
        text-align: center;
    }

    .receipt-stamp-box {
        border: 1px dashed #000;
        min-height: 42px;
        padding-top: 6px;
        font-size: 9pt;
        font-weight: bold;
        box-sizing: border-box;
    }
        `}
    </style>
                                <div className="preview-content ql-editor" style={{ padding: 0 }} dangerouslySetInnerHTML={{ __html: getPreviewHtml() }} />
                            </div>
                            <div className="mt-4 p-3 bg-blue-50 border-left-3 border-blue-500 rounded-right-xl">
                                <div className="flex gap-2">
                                    <i className="pi pi-info-circle text-blue-600 mt-1"></i>
                                    <p className="text-xs text-blue-700 font-medium">
                                        Önizleme alanı 80mm kağıt genişliğini simüle eder. Gerçek yazıcı çıktısı kullanılan kağıt kalitesi ve yazıcı ayarlarına göre farklılık gösterebilir.
                                    </p>
                                </div>
                            </div>
                        </Card>
                    </div>
            </div>
        </div>
    );
}
